export default function cancelarSolicitudRepresentacionService ({ idSolicitud, idcorl, token }) {

    return fetch(`${process.env.REACT_APP_API_SISTEMAREPRESENTACIONES}/representaciones/v1/solicitudRepresentacion/${idSolicitud}`, { //1`, { //
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'HTTP_HEADER_IDCORRELACION': idcorl,
        'HTTP_HEADER_NOMBREAPLICACION': 'HTN.SistemaRepresentaciones.Web',
        'Authorization': token
      }      
    })   
     
    .then((response) => {
        
        return new Promise((resolve) => response.text()
          .then((json) => resolve({
            //status: response.status,
            ok: response.ok,
            json,
          })));
      }).then(({ ok, json }) => {
        const mjeError = ok? '' : (json && JSON.parse(json) && JSON.parse(json).status? JSON.parse(json).status + ': ' +  JSON.parse(json).title : '');   
    
        return { ok: ok, mjeError: mjeError }      
      })
}      
     /*
      .then(response => 
        response.json().then(data => ({
            data: data,
            status: response.status,
            ok : response.ok
        })
    ).then(res => {
        //console.log(res.status, res.data.title)
        const mjeError = res.ok? '' : (res.data && res.data.StatusCode? res.data.StatusCode + ': ' +  res.data.Message : '');   
    
          return { ok: res.ok, mjeError: mjeError }    
    }));
*/
/*
    .then(response => {
        return { ok: response.ok, objJson: response.text() }
      })
      .then((data) => {
        //resolve({ok : data.ok, mjeError: (data ? JSON.parse(data).StatusCode + ': ' +  JSON.parse(data).Message : '') })
        return {ok : data.ok, mjeError: (data ? JSON.parse(data).StatusCode + ': ' +  JSON.parse(data).Message : '') }
      })
    */
